import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { SkeletonText } from '@shared/components/Skeleton';
import { FoilBadge } from '@apps/card/components/FoilBadge';

interface TitleBlockProps {
  title: string;
  subtitle?: string;
  isFoil?: boolean;
}

const Root: React.FC = ({ children }) => {
  return (
    <Flex
      flexDirection="column"
      rowGap={3}
      marginBottom={{ _: 5, sm2: 7 }}
    >
      {children}
    </Flex>
  );
};

// The design name only. The price and promo code that used to sit under it
// now live on the product picker's rows, where they belong to the product
// they describe — repeating the selected row's price up here read as a second
// price and cost vertical room on mobile.
export const TitleBlock = (props: TitleBlockProps) => {
  const { title, subtitle, isFoil = false } = props;

  return (
    <Root>
      {isFoil && <FoilBadge />}
      <TextV2
        fontWeight={{ sm2: 600 }}
        typographyVariant={{ _: 'hed4', sm2: 'display1' }}
      >
        {title}
      </TextV2>
      {subtitle && (
        <TextV2
          color="mono12"
          fontWeight={{ _: 500, sm2: 500 }}
          typographyVariant={{ _: 'hed1', sm2: 'hed4' }}
        >
          {subtitle}
        </TextV2>
      )}
    </Root>
  );
};

TitleBlock.Skeleton = () => {
  return (
    <Root>
      <SkeletonText
        rows={1}
        width={{ _: 160, sm2: 200 }}
        skeletonHeight={{ _: 24, sm2: 30 }}
      />
    </Root>
  );
};
